import React from 'react';

const Mic = () => {
    return (
        <svg width={14.727} height={22} viewBox="0 0 14.727 22">
            <path
                d="M7.363 1a2.727 2.727 0 00-2.727 2.727V11a2.727 2.727 0 005.455 0V3.727A2.727 2.727 0 007.363 1z"
                fill="none"
                stroke="#8F99DC"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
            />
            <path
                d="M13.727 9.182V11A6.364 6.364 0 011 11V9.182M7.364 17v4M3.364 21h8"
                fill="none"
                stroke="#8F99DC"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
            />
        </svg>
    );
};

export default Mic;
